import defaultValues from './default.json';
import type { LocalisationConfigWithLang } from '../types';

const config: LocalisationConfigWithLang = {
  ...defaultValues,
  distanceUnit: 'miles',
  'contact.genericForm.showInContactPanel': true,
  hoursFormat24: false,
  'contact.phone.number': '+1 929 376 0101',
  'contact.phone.officeHours': '1-5|08:00|20:00|America/New_York',
  'apprenticeship.isEnabled': true,
  'apprenticeship.hasTalentPool': true,
  'apprenticeship.agreement.url': '/p/apprenticeship-agreement',
  'page.uplift.url': '/us-apprenticeship-for-business',
  'page.policies_specific_country.url': '/p/regulatory-information',
  'external.appointment.url':
    'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0XYvdBoOZ7g6gPsyOLeiX4fr9bkArRyLnDyltWqJcClb9QsSZqueOEXYPtJyR42CvTxlzGf8F0',
};

export default config;
